import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DialogiMediatuotanto from "./sections/DialogiMediatuotanto";
import DialogueMeaningSection from "./sections/DialogueMeaningSection";
import PalvelummeOrganisaatioille from "./sections/PalvelummeOrganisaatioille";
import ValikoitujaProjekteja from "./sections/ValikoitujaProjekteja";
import PolkuIdeastaJulkaisuun from "./sections/PolkuIdeastaJulkaisuun";
import KeskustellaankoLisaa from "./sections/KeskustellaankoLisaa";
import Alatunniste from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DialogiMediatuotanto />
      <DialogueMeaningSection />
      <PalvelummeOrganisaatioille />
      <ValikoitujaProjekteja />
      <PolkuIdeastaJulkaisuun />
      <KeskustellaankoLisaa id='yhteystiedot' />
      <Alatunniste />
    </div>;
}